/* Partify paint estimator: one shared calculator for the landing page and modal. */
(function () {
  "use strict";

  var booted = false;
  var modal;
  var dialog;
  var state = {
    bodyType: "sedan",
    parts: new Set(["front-door"]),
    damage: "scratch",
    setup: "diy",
    recommendation: null
  };

  var PARTS = {
    "front-bumper": { label: "Front bumper", area: 1.8 },
    hood: { label: "Hood", area: 2.8 },
    "front-fender": { label: "Front fender", area: 1.1 },
    "front-door": { label: "Front door", area: 1.45 },
    "rear-door": { label: "Rear door", area: 1.35 },
    "rear-quarter": { label: "Rear quarter", area: 1.45 },
    trunk: { label: "Trunk / hatch", area: 1.7 },
    "rear-bumper": { label: "Rear bumper", area: 1.8 },
    roof: { label: "Roof", area: 3.5 }
  };
  var DAMAGE = {
    scratch: { factor: 0.38 },
    deep: { factor: 0.78 },
    panel: { factor: 1.45 }
  };

  function $(selector, root) { return (root || document).querySelector(selector); }
  function $all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function boards() { return $all("[data-pae-board]"); }
  function normalize(value) { return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, ""); }
  function amount(value) { return (Math.round(value * 100) / 100).toString().replace(/\.0+$/, "") + " oz"; }
  function roundQuarter(value) { return Math.max(0.25, Math.ceil(value * 4) / 4); }
  function selectedParts() { return Array.from(state.parts).map(function (id) { return PARTS[id]; }).filter(Boolean); }

  function chipAmount(panelCount) {
    /* A chip is a localized defect. More selected panels mean more chip locations,
       not a full-panel paint calculation. */
    if (panelCount <= 1) return 0.1;
    if (panelCount <= 3) return 0.2;
    if (panelCount <= 6) return 0.35;
    return 0.5;
  }
  function calculate() {
    var parts = selectedParts();
    var totalArea = parts.reduce(function (total, part) { return total + part.area; }, 0);
    var needed = state.damage === "chip"
      ? chipAmount(parts.length)
      : roundQuarter(totalArea * DAMAGE[state.damage].factor * 1.22);
    var format;
    var buy;
    var quantity = 1;
    var copy;

    if (state.damage === "chip") {
      format = "Pen";
      buy = 0.5;
      copy = "A paint pen is the lowest-waste choice for a localized chip, even when more than one chip is selected.";
    } else if (state.setup === "professional") {
      if (needed <= 8) { format = "Half Pint"; buy = 8; copy = "A half pint gives a spray setup the application allowance needed for this repair."; }
      else if (needed <= 16) { format = "Pint"; buy = 16; copy = "A pint is the sensible professional volume for this repair scope."; }
      else if (needed <= 32) { format = "Quart"; buy = 32; copy = "A quart gives enough material to cover and blend the selected work."; }
      else { format = "Gallon"; buy = 128; copy = "This job calls for shop-scale volume. Confirm your spray plan before ordering."; }
    } else if (needed <= 0.5) {
      format = "Pen"; buy = 0.5; copy = "A paint pen is the lowest-waste choice for pinpoint chips and very fine scratches.";
    } else if (needed <= 1.5) {
      format = "Bottle"; buy = 1; copy = "A one-ounce bottle is the right starting point for a controlled touch-up repair.";
    } else if (needed <= 5) {
      format = "Aerosol"; buy = 12; copy = "An aerosol gives broader, more even coverage for this repair.";
    } else {
      format = "Aerosol"; buy = 12; quantity = Math.ceil(needed / buy); copy = "Use multiple aerosols for this repair, or choose professional spray if you have a spray gun.";
    }

    state.recommendation = {
      format: format,
      buy: buy,
      needed: needed,
      quantity: quantity,
      copy: copy,
      areas: parts.map(function (part) { return part.label; }).join(", ")
    };
    return state.recommendation;
  }

  function updatePartControls() {
    var labels = selectedParts().map(function (part) { return part.label; });
    boards().forEach(function (board) {
      $all("[data-pae-part]", board).forEach(function (control) {
        control.setAttribute("aria-pressed", String(state.parts.has(control.getAttribute("data-pae-part"))));
      });
      $all("[data-pae-panel]", board).forEach(function (panel) {
        panel.classList.toggle("is-selected", state.parts.has(panel.getAttribute("data-pae-panel")));
      });
      var note = $("[data-pae-selection-note]", board);
      if (note) note.textContent = labels.length + " area" + (labels.length === 1 ? "" : "s") + " selected: " + labels.join(", ");
    });
  }
  function updateBodyType() {
    boards().forEach(function (board) {
      $all("[data-pae-body-type]", board).forEach(function (button) {
        button.classList.toggle("is-selected", button.getAttribute("data-pae-body-type") === state.bodyType);
      });
      var car = $("[data-pae-car]", board);
      if (car) car.setAttribute("data-pae-body", state.bodyType);
    });
  }
  function updateDamage() {
    boards().forEach(function (board) {
      $all("[data-pae-damage]", board).forEach(function (button) {
        var selected = button.getAttribute("data-pae-damage") === state.damage;
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-checked", String(selected));
      });
    });
  }
  function updateSetup() {
    boards().forEach(function (board) {
      $all("[data-pae-setup]", board).forEach(function (button) {
        var selected = button.getAttribute("data-pae-setup") === state.setup;
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-checked", String(selected));
      });
    });
  }
  function selectedColorEntries() {
    var select = document.getElementById("variant-selector");
    var map = window.__touchupSizeMap || {};
    if (!select || !select.value || !map || typeof map !== "object") return [];
    var option = select.options[select.selectedIndex];
    var code = option ? String(option.textContent || "").trim() : "";
    var exact = map[code] || map[String(code).toUpperCase()] || [];
    if (Array.isArray(exact) && exact.length) return exact;
    var selectedId = String(select.value);
    return Object.keys(map).reduce(function (entries, key) { return entries.concat(Array.isArray(map[key]) ? map[key] : []); }, []).filter(function (entry) { return String(entry.id) === selectedId; });
  }
  function findRecommendedVariant(rec) {
    var target = normalize(rec && rec.format);
    var selectedId = String((document.getElementById("variant-selector") || {}).value || "");
    if (!target || !selectedId) return null;
    return selectedColorEntries().find(function (entry) { return entry && entry.available !== false && normalize(entry.size) === target; }) || null;
  }
  function updateResult() {
    var rec = calculate();
    var variant = findRecommendedVariant(rec);
    boards().forEach(function (board) {
      var format = $("[data-pae-result-format]", board);
      var copy = $("[data-pae-result-copy]", board);
      var needed = $("[data-pae-result-needed]", board);
      var buy = $("[data-pae-result-buy]", board);
      var primer = $("[data-pae-primer]", board);
      var clear = $("[data-pae-clear]", board);
      var cartMessage = $("[data-pae-cart-message]", board);
      var cta = $("[data-pae-add-to-cart]", board);
      if (format) format.textContent = rec.quantity > 1 ? rec.quantity + " x " + rec.format : rec.format;
      if (copy) copy.textContent = rec.copy;
      if (needed) needed.textContent = amount(rec.needed);
      if (buy) buy.textContent = (rec.quantity > 1 ? rec.quantity + " x " : "") + amount(rec.buy);
      if (primer) primer.textContent = state.damage === "deep" || state.damage === "panel" ? "Recommended" : "If bare metal is exposed";
      if (clear) clear.textContent = "Recommended for gloss repairs";
      if (variant) {
        if (cartMessage) cartMessage.textContent = "Your exact color is selected. Add this " + rec.format.toLowerCase() + " recommendation directly to cart.";
        if (cta) cta.innerHTML = "Add recommended paint to cart <span aria-hidden=\"true\">&rarr;</span>";
      } else {
        if (cartMessage) cartMessage.textContent = "Select your vehicle and exact paint color before adding this recommendation to cart.";
        if (cta) cta.innerHTML = "Choose my exact color <span aria-hidden=\"true\">&rarr;</span>";
      }
    });
  }
  function updateAll() {
    updateBodyType(); updatePartControls(); updateDamage(); updateSetup(); updateResult();
  }
  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add("pae-modal-open");
    document.body.classList.add("pae-modal-open");
    updateAll();
    setTimeout(function () { if (dialog) dialog.focus(); }, 0);
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove("pae-modal-open");
    document.body.classList.remove("pae-modal-open");
  }
  function openExactColorFlow() {
    var finder = $("[data-tuf-open]");
    if (finder) { finder.click(); return; }
    openGarage();
  }
  function setCartState(disabled, label) {
    $all("[data-pae-add-to-cart]").forEach(function (button) {
      button.disabled = disabled;
      if (label) button.textContent = label;
    });
  }
  function addToCart() {
    var rec = state.recommendation || calculate();
    var entry = findRecommendedVariant(rec);
    if (!entry) { openExactColorFlow(); return; }
    setCartState(true, "Adding your recommendation...");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({
        id: Number(entry.id), quantity: rec.quantity,
        properties: {
          "Repair estimate": amount(rec.needed) + " base color",
          "Recommended format": rec.format,
          "Repair areas": rec.areas,
          "Paint setup": state.setup === "professional" ? "Professional spray setup" : "DIY touch-up"
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to add this recommendation");
      return response.json();
    }).then(function () { window.location.assign("/cart"); }).catch(function () {
      setCartState(false);
      updateResult();
      $all("[data-pae-cart-message]").forEach(function (message) {
        message.textContent = "We could not add this recommendation. Review your selected color and try again.";
      });
    });
  }
  function openGarage() {
    closeModal();
    setTimeout(function () {
      if (window.GarageV2 && typeof window.GarageV2.open === "function") window.GarageV2.open();
      else if (typeof window.toggleGaragePopup === "function") window.toggleGaragePopup();
    }, 50);
  }
  function bind() {
    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest ? event.target.closest("[data-pae-open], [data-pae-close], [data-pae-add-to-cart], [data-pae-body-type], [data-pae-part], [data-pae-damage], [data-pae-setup]") : null;
      if (!target) return;
      if (target.hasAttribute("data-pae-open")) { event.preventDefault(); openModal(); return; }
      if (target.hasAttribute("data-pae-close")) { closeModal(); return; }
      if (!target.closest("[data-pae-board]")) return;
      if (target.hasAttribute("data-pae-add-to-cart")) { addToCart(); return; }
      if (target.hasAttribute("data-pae-body-type")) { state.bodyType = target.getAttribute("data-pae-body-type"); updateBodyType(); return; }
      if (target.hasAttribute("data-pae-part")) {
        var part = target.getAttribute("data-pae-part");
        if (!PARTS[part]) return;
        if (state.parts.has(part) && state.parts.size > 1) state.parts.delete(part);
        else state.parts.add(part);
        updatePartControls(); updateResult(); return;
      }
      if (target.hasAttribute("data-pae-damage")) { state.damage = target.getAttribute("data-pae-damage"); updateDamage(); updateResult(); return; }
      if (target.hasAttribute("data-pae-setup")) { state.setup = target.getAttribute("data-pae-setup"); updateSetup(); updateResult(); }
    });
    window.addEventListener("partify:vehicle:changed", updateAll);
    window.addEventListener("searchTermsUpdated", updateAll);
  }
  function boot() {
    if (booted) return;
    modal = $("[data-pae-modal]");
    if (!modal && !$("[data-pae-board]")) return;
    booted = true;
    dialog = modal ? $(".pae-modal__dialog", modal) : null;
    bind();
    updateAll();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
